import React from 'react';
import { Instagram, Facebook, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = ({ businessInfo, showAfterHoursWarning }) => {
  return (
    <section
      className="relative pb-20 px-6 overflow-hidden"
      // Valor CONSTANTE (igual en prerender y primer render del cliente) para que
      // la hidratación no rompa. --brazo-header-h la setea Home tras medir el
      // header; el fallback 96px evita que el hero quede bajo el header fijo
      // antes de que JS mida.
      style={{ paddingTop: 'calc(var(--brazo-header-h, 96px) + 24px)' }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-cream via-white to-peach opacity-60"></div>
      <div className="container mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-5xl md:text-6xl font-bold text-chocolate leading-tight">
              Brazos Gitanos Artesanales
              <span className="block text-caramel">en Quito</span>
            </h1>
            <p className="text-xl text-chocolate-light leading-relaxed">
              {businessInfo.description}
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#productos"
                className="inline-flex items-center bg-[#4a2c2a] hover:bg-[#3a1c1a] text-white px-8 py-4 text-lg shadow-xl hover:shadow-2xl transition-all duration-200 rounded-md font-medium"
              >
                Hacer un Pedido
                <ChevronRight className="ml-2" />
              </a>
              <Button 
                variant="outline" 
                size="lg"
                className="border-2 border-chocolate text-chocolate hover:bg-chocolate hover:text-white px-8 py-6 text-lg transition-all"
                onClick={() => document.getElementById('productos').scrollIntoView({ behavior: 'smooth' })}
              >
                Ver Menú
              </Button>
            </div>
            <div className="flex items-center space-x-4 pt-4">
              <a href={businessInfo.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram de Brazolovers" className="text-chocolate hover:text-caramel transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href={businessInfo.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook de Brazolovers" className="text-chocolate hover:text-caramel transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src="/images/B01_Manjar.webp"
                alt="Brazo Gitano Manjar"
                className="w-full h-full object-cover"
                loading="eager"
                fetchpriority="high"
                width="600"
                height="600"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="text-4xl font-bold text-caramel">+40</div>
              <div className="text-chocolate font-medium">Sabores Únicos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
